module.exports = __webpack_public_path__ + "img/37.c0a3daa9.png";